import { type Patient, type RestrictionStatus as RestrictionStatusType } from '@/types/patient'
import { Badge } from '@quickmd-llc/design-system'

type Props = {
  patient: Patient
}

const optionsByRestrictionStatus: Record<
  RestrictionStatusType,
  { label: string; variant: 'active' | 'warning' | 'error' }
> = {
  drugscreenrequired: {
    label: 'Must complete drug screen',
    variant: 'warning',
  },
  inpersonvisitrequired: {
    label: 'Must complete in-person visit',
    variant: 'warning',
  },
  merged: {
    label: 'Merged account',
    variant: 'error',
  },
  none: {
    label: 'Compliant',
    variant: 'active',
  },
  onhold: {
    label: 'On hold',
    variant: 'error',
  },
}

export function ComplianceBadge({ patient }: Props) {
  const { RestrictionStatus } = patient

  const { label, variant } = optionsByRestrictionStatus[RestrictionStatus]

  return (
    <Badge size='s' variant={variant}>
      {label}
    </Badge>
  )
}
